"use client"
import { Skeleton } from 'primereact/skeleton';
import './HomeSkeleton.scss';
import { useEffect } from 'react';
import { useAppDispatch } from '@Src/app/hooks';
import { clearUserData } from '@Src/app/reducers/auth/loginSlice';
import { clearCoursePreferences } from '@Src/app/reducers/auth/coursePreferencesSlice';
import { useLocation, useSearchParams } from 'react-router-dom';
import { AppRouteURL } from '@Constants/app-route-url.constant';
import { isLoggedIn } from '@Src/utils/service/app.utility.service';
import { persistor } from '@Src/app/store';

export const HomeSkeleton = () => {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const location = useLocation();


    console.log(location);


    useEffect(() => {
        const logout = async () => {

            dispatch(clearUserData());
            dispatch(clearCoursePreferences());
            try {
                await persistor.purge();
            } catch (error) {
                console.error("Persistor purge error:", error);
            }

            localStorage.removeItem('persist:root');
            localStorage.removeItem('redirectAfterSubscription');
            window.location.replace(String(process.env.REACT_APP_MAIN_SITE_URL));
        }


        if (searchParams.get("logout") == "true") {

            logout();


        } else {
            if ((location.pathname === "/" || location.pathname === '/')) {
                window.location.replace(String(process.env.REACT_APP_MAIN_SITE_URL));
            }
        }




    }, [searchParams])
    return (
        <div className="home-skeleton">
            <header className="home-skeleton-header">
                <div className="home-skeleton-brand">
                    <Skeleton width="170px" height="40px" />
                </div>
                <div className="tw-flex tw-gap-5 " style={{ width: "50%" }}>
                    <div className="home-skeleton-nav">
                        <Skeleton width="60px" height="20px" className="home-skeleton-nav-item" />
                        <Skeleton width="60px" height="20px" className="home-skeleton-nav-item" />
                        <Skeleton width="80px" height="20px" className="home-skeleton-nav-item" />
                        <Skeleton width="80px" height="20px" className="home-skeleton-nav-item" />
                        <Skeleton width="80px" height="20px" className="home-skeleton-nav-item" />
                    </div>
                    <div className="home-skeleton-actions" style={{ width: "150px" }}>

                        <Skeleton width="150px" height="40px" className="home-skeleton-action" />
                    </div>
                </div>

            </header>

            <section className="home-skeleton-hero">
                <div className="home-skeleton-hero-content">
                    <Skeleton width="240px" height="30px" className="home-skeleton-hero-tag" />
                    <Skeleton width="1000px" height="80px" className="home-skeleton-hero-title" />
                    <Skeleton width="1100px" height="25px" className="home-skeleton-hero-subtitle" />
                    <div className="home-skeleton-hero-buttons">
                        <Skeleton width="250px" height="48px" className="mr-3" />

                    </div>
                </div>
            </section>

            {/* <section className="home-skeleton-features">
                <div className="home-skeleton-feature-card">
                    <Skeleton width="100px" height="18px" className="mb-3" />
                    <Skeleton width="100%" height="16px" className="mb-2" />
                    <Skeleton width="90%" height="16px" />
                </div>
                <div className="home-skeleton-feature-card">
                    <Skeleton width="100px" height="18px" className="mb-3" />
                    <Skeleton width="100%" height="16px" className="mb-2" />
                    <Skeleton width="90%" height="16px" />
                </div>
                <div className="home-skeleton-feature-card">
                    <Skeleton width="100px" height="18px" className="mb-3" />
                    <Skeleton width="100%" height="16px" className="mb-2" />
                    <Skeleton width="90%" height="16px" />
                </div>
            </section> */}
            <section className="home-skeleton-score-section">
                <div className="home-skeleton-score-content">

                    {/* Left Section */}
                    <div className="home-skeleton-score-left">

                        <Skeleton width="380px" height="42px" className="mb-3" />
                        <Skeleton width="280px" height="20px" className="mb-4" />
                        <Skeleton width="420px" height="24px" className="mb-5" />

                        <div className="tw-flex tw-justify-between">

                            {/* Card 1 */}
                            <div className="home-skeleton-score-card" style={{ borderRight: "0.5px solid lightgrey" }}>
                                <Skeleton shape="circle" size="56px" className="mb-3" />
                                <Skeleton width="180px" height="24px" className="mb-2" />
                                <Skeleton width="150px" height="18px" className="mb-2" />
                                <Skeleton width="220px" height="16px" className="mb-1" />
                                <Skeleton width="200px" height="16px" className="mb-4" />
                                <Skeleton width="170px" height="44px" />
                            </div>



                            {/* Card 2 */}
                            <div className="home-skeleton-score-card">
                                <Skeleton shape="circle" size="56px" className="mb-3" />
                                <Skeleton width="180px" height="24px" className="mb-2" />
                                <Skeleton width="170px" height="18px" className="mb-2" />
                                <Skeleton width="220px" height="16px" className="mb-1" />
                                <Skeleton width="200px" height="16px" className="mb-4" />
                                <Skeleton width="170px" height="44px" />
                            </div>

                        </div>
                    </div>

                    {/* Right Image */}
                    <div className="home-skeleton-score-right">
                        <Skeleton width="520px" height="350px" borderRadius="24px" />
                    </div>

                </div>
            </section>
        </div>
    );
};
